import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";

"use strict";
ko.bindingHandlers.sideflagged = {
    init: function (elt, va, allbindings, model, context) {
        var search_settings = ko.observable({
            "navigable": false,
            "contextual": false,
            "facets_visible": false,
            "show_controls": false,
            "selection_aware": false,
            "actions_visible": false,
            "search_placeholder": _('search_flagged_placeholder', 'Search Flagged Records'),
            "filter": "is:flagged",
            "parameters": { _search_body: null }
        });

        uly.subscribe("entity.flagged", function () {
            //hack to get at the model
            var model = $(elt).children(".search").data("search_model");
            if (model) {
                model.query_results();
            }
        }, elt);
        uly.subscribe("entity.unflagged", function () {
            //hack to get at the model
            var model = $(elt).children(".search").data("search_model");
            if (model) {
                model.query_results();
            }
        }, elt);

        var child = context.createChildContext({ "settings": search_settings });
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    }
};

$.extend(uly.actions, {
    unflag: function(ev, $elt, ui) {
        var vals = uly.actions.get_$elt_and_ui(ev, ui, "unflag");
        $elt = vals[0];
        ui = vals[1];

        uly.actions.standard_action(ev, $elt, ui).then(function (result) {
            uly.publish("entity.unflagged");
        });
    },
    flag: function (ev, $elt, ui) {
        var vals = uly.actions.get_$elt_and_ui(ev, ui, "flag");
        $elt = vals[0];
        ui = vals[1];

        return uly.actions.standard_action(ev, $elt, ui).then(function (result) {
            uly.publish("entity.flagged");
        });
    },
    deletetag: function(ev, $elt, ui) {
        console.log("Deleting tag", ui);
        var tag = ui.model;
        var vals = uly.actions.get_$elt_and_ui(ev, ui, "deletetag");
        console.log("tag:", tag, "vals:", vals, "ui:", ui);
        ui.post_data= {tag: tag};
        
        return uly.actions.standard_action(ev, $elt, ui).then(function (result) {
            uly.publish("entity.tag.removed");
        });
    },
    searchbytag: function(ev, $elt, ui) {
    }
});
